import React = require("react");
import {MarketingConfig} from "../data/MarketingConfig";
import {MarketingData} from "../data/MarketingData";
import {MarketingTabMapper} from "../utils/MarketingTabMapper";
import {AssetBaseWidget} from "../widgets/AssetBaseWidget";
import {HistogramChartWidget} from "../widgets/HistogramChartWidget";
import {LargeHistogramChartWidget} from "../widgets/LargeHistogramChartWidget";
import {LargeHistogramChartWidget2Axis} from "../widgets/LargeHistogramChartWidget2Axis";
import {LargeHistogramGroupChartWidget} from "../widgets/LargeHistogramGroupChartWidget";
import {LocationsTrendWidget} from "../widgets/LocationsTrendWidget";
import {MarketingSalesWidget} from "../widgets/MarketingSalesWidgetWithYearAgo";
import {MarketingSalesWithBestWidget} from "../widgets/MarketingSalesWithBestWidget";

import UnitOfMeasure = MarketingConfig.UnitOfMeasure;
import MarketingDataConverter = MarketingData.MarketingDataConverter;

interface MarketingTabMonthProps {
    configuration: MarketingConfig.Container;
    dataMonth: MarketingData.PeriodData;
    goToLocation: () => any;
    unitOfMeasure: UnitOfMeasure;
    isDetailLevel: boolean;
}

/**
 * Month to date marketing report.
 */
export class MarketingTabMonth extends React.Component<MarketingTabMonthProps, {}> {

    constructor(props: MarketingTabMonthProps) {
        super(props);
    }

    public render() {
        return (
            <div className="marketing-tab__widgets">
                {this.getWidgets()}
            </div>
        );
    }

    private getWidgets(): JSX.Element[] {
        const config = this.props.configuration;
        const data: MarketingData.PeriodData = JSON.parse(JSON.stringify(this.props.dataMonth));
        const assetsConfig = config.assets;
        const assetsData = data.assets;
        const unitOfMeasure = this.props.unitOfMeasure;

        const bestLocations = MarketingTabMapper.locationTrendRows(data.bestLocations, unitOfMeasure);
        const bestProduct = MarketingTabMapper.bestProduct(data.productSales, unitOfMeasure);
        const productSalesRows = MarketingTabMapper.productSaleRowMapper(
            data.productSales.productSaleRows,
            this.props.unitOfMeasure,
        );
        const dayIntervalSalesRows = MarketingTabMapper.dayIntervalSaleRowMapper(
            data.dayIntervalSales,
            this.props.unitOfMeasure,
        );
        const weekdaySales = MarketingTabMapper.weekdaySaleRowMapper(
            data.weekdaySales,
            this.props.unitOfMeasure,
        );
        const productSelectionAverageMonthToDate = MarketingTabMapper.productSelectionAverageMonthToDateMapper(
            data.productSelectionsAverages,
            this.props.unitOfMeasure,
        );
        const weekdayDayIntervalSales = MarketingTabMapper.weekDayDayIntervalSalesMapper(
            data.weekdayDayIntervalSales,
            this.props.unitOfMeasure,
        );
        const result = [];
        result.push(
            (
                <div
                    className={"marketing-2x2-widgets-container "}
                >
                    <AssetBaseWidget
                        title={assetsConfig.title}
                        locations={{name: assetsConfig.locationsTitle, count: assetsData.locations}}
                        telemetryKits={{name: assetsConfig.telemetriesTitle, count: assetsData.telemetries}}
                        selections={{name: assetsConfig.selectionsTitle, count: assetsData.selections}}
                        unitOfMeasure={unitOfMeasure}

                    />
                    <MarketingSalesWidget
                        period={config.periods.month}
                        yearAgoPeriod={config.periods.yearAgo}
                        twoYearsAgoPeriod={config.periods.twoYearsAgo}
                        displayTwoYearsAgo={true}
                        title={config.salesTitle}
                        titleSalesTotals={config.salesTotals.title}
                        titleLocationAverage={config.salesAverages.locationAverageTitle}
                        titleSelectionAverage={config.salesAverages.selectionAverageTitle}
                        titleEquipmentAverage={config.salesAverages.equipmentAverageTitle}
                        unitOfMeasure={unitOfMeasure}
                        sales={{
                            title: config.salesTotals.title,
                            quantity: MarketingDataConverter.chooseAndConvertValue(
                                data.sales,
                                data.consumptions,
                                unitOfMeasure,
                            ),
                            unitOfMeasure: unitOfMeasure.symbol,
                        }}
                        salesYearAgo={{
                            title: config.salesTotals.title,
                            quantity: MarketingDataConverter.chooseAndConvertValue(
                                data.salesYearAgo,
                                data.consumptionsYearAgo,
                                unitOfMeasure,
                            ),
                            unitOfMeasure: unitOfMeasure.symbol,
                        }}
                        salesTwoYearsAgo={{
                            title: config.salesTotals.title,
                            quantity: MarketingDataConverter.chooseAndConvertValue(
                                data.salesTwoYearsAgo,
                                data.consumptionsTwoYearsAgo,
                                unitOfMeasure,
                            ),
                            unitOfMeasure: unitOfMeasure.symbol,
                        }}
                        locationAvg={{
                            title: config.salesAverages.locationAverageTitle,
                            quantity: MarketingDataConverter.chooseAndConvertValue(
                                data.salesLocationAverages,
                                data.consumptionsLocationAverages,
                                unitOfMeasure,
                            ),
                            unitOfMeasure: unitOfMeasure.symbol,
                        }}
                        selectionAvg={{
                            title: config.salesAverages.selectionAverageTitle,
                            quantity: MarketingDataConverter.chooseAndConvertValue(
                                data.salesSelectionAverages,
                                data.consumptionsSelectionAverages,
                                unitOfMeasure,
                            ),
                            unitOfMeasure: unitOfMeasure.symbol,
                        }}
                        equipmentAvg={{
                            title: config.salesAverages.equipmentAverageTitle,
                            quantity: MarketingDataConverter.chooseAndConvertValue(
                                data.salesEquipmentAverages,
                                data.consumptionsEquipmentAverages,
                                unitOfMeasure,
                            ),
                            unitOfMeasure: unitOfMeasure.symbol,
                        }}
                        locationAvgYearAgo={{
                            title: config.salesAverages.locationAverageTitle,
                            quantity: MarketingDataConverter.chooseAndConvertValue(
                                data.salesLocationAveragesYearAgo,
                                data.consumptionsLocationAveragesYearAgo,
                                unitOfMeasure,
                            ),
                            unitOfMeasure: unitOfMeasure.symbol,
                        }}
                        selectionAvgYearAgo={{
                            title: config.salesAverages.selectionAverageTitle,
                            quantity: MarketingDataConverter.chooseAndConvertValue(
                                data.salesSelectionAveragesYearAgo,
                                data.consumptionsSelectionAveragesYearAgo,
                                unitOfMeasure,
                            ),
                            unitOfMeasure: unitOfMeasure.symbol,
                        }}
                        equipmentAvgYearAgo={{
                            title: config.salesAverages.equipmentAverageTitle,
                            quantity: MarketingDataConverter.chooseAndConvertValue(
                                data.salesEquipmentAveragesYearAgo,
                                data.consumptionsEquipmentAveragesYearAgo,
                                unitOfMeasure,
                            ),
                            unitOfMeasure: unitOfMeasure.symbol,
                        }}
                        locationAvgTwoYearsAgo={{
                            title: config.salesAverages.locationAverageTitle,
                            quantity: MarketingDataConverter.chooseAndConvertValue(
                                data.salesLocationAveragesTwoYearsAgo,
                                data.consumptionsLocationAveragesTwoYearsAgo,
                                unitOfMeasure,
                            ),
                            unitOfMeasure: unitOfMeasure.symbol,
                        }}
                        selectionAvgTwoYearsAgo={{
                            title: config.salesAverages.selectionAverageTitle,
                            quantity: MarketingDataConverter.chooseAndConvertValue(
                                data.salesSelectionAveragesTwoYearsAgo,
                                data.consumptionsSelectionAveragesTwoYearsAgo,
                                unitOfMeasure,
                            ),
                            unitOfMeasure: unitOfMeasure.symbol,
                        }}
                        equipmentAvgTwoYearsAgo={{
                            title: config.salesAverages.equipmentAverageTitle,
                            quantity: MarketingDataConverter.chooseAndConvertValue(
                                data.salesEquipmentAveragesTwoYearsAgo,
                                data.consumptionsEquipmentAveragesTwoYearsAgo,
                                unitOfMeasure,
                            ),
                            unitOfMeasure: unitOfMeasure.symbol,
                        }}
                    />
                </div>
            ),
        );
        if (this.props.configuration.isDeprecatedCompany2) {
            if (!this.props.isDetailLevel) {
                result.push(
                    (
                        <LocationsTrendWidget
                            title={config.locationsRanks.title}
                            bestLocationsData={bestLocations}
                            goToLocation={this.props.goToLocation}
                            unitOfMeasure={unitOfMeasure.symbol}
                            wide={true}
                        />
                    ),
                );
            }
        } else {
            result.push(
                (
                    <MarketingSalesWithBestWidget
                        title={config.productSales.title}
                        bestSaleEntityData={
                            {
                                title: config.productSales.bestProductTitle,
                                name: bestProduct.productName,
                                percentageOfTotal: bestProduct.percentage,
                                quantity: bestProduct.value,
                                unitOfMeasure: unitOfMeasure.symbol,
                                color: MarketingTabMapper.getProductColor(
                                    bestProduct.productName,
                                    data.productSales.productSaleRows,
                                ),
                            }
                        }
                        chartDataSet={productSalesRows}
                        wide={true}
                    />
                ),
            );
            if (!this.props.isDetailLevel) {
                result.push(
                    (
                        <LocationsTrendWidget
                            title={config.locationsRanks.title}
                            bestLocationsData={bestLocations}
                            goToLocation={this.props.goToLocation}
                            unitOfMeasure={unitOfMeasure.symbol}
                            wide={false}
                        />
                    ),
                );
            }
        }
        if (!MarketingDataConverter.isUnitsUnitOfMeasure(this.props.unitOfMeasure)) {
            result.push(
                (
                    <LargeHistogramChartWidget2Axis
                        title={config.productSelectionsAveragesTitle}
                        data={productSelectionAverageMonthToDate}
                        yUnitOfMeasure={unitOfMeasure.name}
                        y1UnitOfMeasure={config.assets.selectionsTitle}
                    />
                ),
            );
        }
        const dayIntervalSalesWidget = (
            <LargeHistogramChartWidget
                title={config.dayIntervalSales.title}
                data={dayIntervalSalesRows}
                yUnitOfMeasure={unitOfMeasure.name}
            />
        );
        const weekDaySalesWidget = (
            <HistogramChartWidget
                title={config.weekdaySalesTitle}
                data={weekdaySales}
                yUnitOfMeasure={unitOfMeasure.name}
            />
        );
        if (this.props.isDetailLevel && !MarketingDataConverter.isUnitsUnitOfMeasure(unitOfMeasure)) {
            result.push(
                weekDaySalesWidget,
            );
            result.push(
                dayIntervalSalesWidget,
            );
        } else {
            result.push(
                dayIntervalSalesWidget,
            );
            result.push(
                weekDaySalesWidget,
            );
        }
        result.push(
            (
                <LargeHistogramGroupChartWidget
                    title={config.weekDayDayIntervalSalesTitle}
                    data={weekdayDayIntervalSales}
                    yUnitOfMeasure={unitOfMeasure.name}
                />
            ),
        );
        return result;
    }
}
